import React, {useEffect} from 'react';

import {colors} from '../classes/Colors';
import ImageNavCardLayout from '../components/ImageNavCard/ImageNavCardLayout';
import LoadingBar from '../components/LoadingBar';
import {useAcknowledgements} from '../context/AcknowledgementsContext';
import {EVENT_NAMES, CONTENT_TYPES, SCREEN_NAMES} from '../constants/events';
import {logAnalyticsEvent} from '../utils/firebase';
import MaxWidthContainer from '../components/MaxWidthContainer';
import ScreenComponent from '../components/ScreenComponent';

const PSIRFDashboardScreen = ({navigation, ...rest}) => {
  const {isContentAcknowledged} = useAcknowledgements('psirf');
  const data = navigation.getParam('data', []);
  const title = navigation.getParam('title', 'PSIRF');
  const from = navigation.getParam('from', 'unknown');
  const quizOnPressHandler = navigation.getParam('quizOnPressHandler', () =>
    console.log('quiz on press missing'),
  );

  useEffect(() => {
    try {
      logAnalyticsEvent(EVENT_NAMES.screen, {
        screen_name: SCREEN_NAMES.psirfDashboard,
        from,
      });
    } catch (error) {
      console.log(error);
    }
  }, [from]);

  if (!data) {
    return null;
  }

  const navigationHandler = item =>
    navigation.navigate(
      'PSIRF',
      {data: item, quizOnPressHandler},
      {navigation, ...rest},
    );

  const onPressHandler = item => {
    logAnalyticsEvent(EVENT_NAMES.started, {
      from: SCREEN_NAMES.psirfDashboard,
      content_id: item.ID,
      content_type: CONTENT_TYPES.psirf,
    });
    navigationHandler(item);
  };

  const transformedData = data.map(d => {
    const topSection = d.content.find(section => section.type === 'TopSection');
    const image = topSection?.content.TopImage[0].url;
    const displayDate = topSection?.content.DisplayDate;
    const isAcknowledged = isContentAcknowledged(d.ID);
    const statusText = isAcknowledged ? 'Acknowledged' : 'Unacknowledged';
    const onPress = () => onPressHandler(d);
    return {
      id: d.ID,
      onPress,
      getImage: () => image,
      title: d.Name,
      subtitle: d.DisplayTitle,
      trust: d.Trust,
      displayDate,
      status: isAcknowledged,
      statusText,
    };
  });

  return (
    <ScreenComponent style={{flex: 1, backgroundColor: colors.white}}>
      <LoadingBar screenProps={rest.screenProps} />
      <MaxWidthContainer contentContainerStyle={{flex: 1}}>
        <ImageNavCardLayout data={transformedData} title={title} />
      </MaxWidthContainer>
    </ScreenComponent>
  );
};

// Use static navigationOptions to set the header options in React Navigation v4
PSIRFDashboardScreen.navigationOptions = ({navigation}) => {
  return {
    title: '',
    headerStyle: navigation.getParam('headerStyle', {
      backgroundColor: colors.NavBar,
    }),
    headerTintColor: navigation.getParam('headerTintColor', colors.white),
    headerTitleStyle: navigation.getParam('headerTitleStyle', {
      fontFamily: 'InterUI-Regular',
      fontSize: 17,
      fontWeight: '600',
      letterSpacing: -0.41,
      color: colors.white,
    }),
  };
};

export default PSIRFDashboardScreen;
